var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.51074 6.76074L1.51074 2.26074C1.51074 2.06183 1.58976 1.87106 1.73041 1.73041C1.87106 1.58976 2.06183 1.51074 2.26074 1.51074C2.45965 1.51074 2.65042 1.58976 2.79107 1.73041C2.93173 1.87106 3.01074 2.06183 3.01074 2.26074L3.01074 3.01074C2.83501 3.18648 2.93752 14.084 3.01074 19.5107L3.01074 21.0107L21.7607 21.0107C21.9597 21.0107 22.1504 21.0898 22.2911 21.2304C22.4317 21.3711 22.5107 21.5618 22.5107 21.7607C22.5107 21.9597 22.4317 22.1504 22.2911 22.2911C22.1504 22.4317 21.9597 22.5107 21.7607 22.5107L3.01074 22.5107C1.40837 22.4804 1.46134 20.8831 1.50405 19.5952C1.51412 19.2917 1.52361 19.0053 1.51074 18.7607L1.51074 6.76074Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 3.01074L4.5 3.01074C4.22386 3.01074 4 3.2346 4 3.51074L4 7.01074C4 7.28688 4.22386 7.51074 4.5 7.51074L13.25 7.51074L13.2528 7.51074C13.4507 7.51 13.6403 7.43106 13.7803 7.29107C13.921 7.15042 14 6.95965 14 6.76074L14 3.76074C14 3.56183 13.921 3.37106 13.7803 3.23041C13.6397 3.08976 13.4489 3.01074 13.25 3.01074ZM9.98926 9.50949C9.98926 9.23334 9.7654 9.01074 9.48926 9.01074L4.5 9.01074C4.22386 9.01074 4 9.2346 4 9.51074L4 13.0063C4 13.2842 4.2252 13.5088 4.50304 13.5063C5.58454 13.4969 8.17946 13.4742 9.98926 13.4583C7.75171 13.4926 7.98926 13.5 9.98926 13.4583C9.98926 12.1798 9.98926 10.3738 9.98926 9.50949ZM4.5 19.5107C4.22386 19.5107 4 19.2869 4 19.0107L4 15.5107C4 15.2346 4.22386 15.0107 4.5 15.0107L13.75 15.0107C13.9489 15.0107 14.1397 15.0898 14.2803 15.2304C14.421 15.3711 14.5 15.5618 14.5 15.7607L14.5 18.7607C14.5 18.9597 14.421 19.1504 14.2803 19.2911C14.1397 19.4317 13.9489 19.5107 13.75 19.5107L4.5 19.5107Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2528 7.51074C13.4507 7.51 13.6403 7.43106 13.7803 7.29107C13.921 7.15042 14 6.95965 14 6.76074L14 3.76074C14 3.56183 13.921 3.37106 13.7803 3.23041C13.6397 3.08976 13.4489 3.01074 13.25 3.01074L18.4883 3.00094C18.7648 3.00042 18.9893 3.22443 18.9893 3.50094L18.9893 7.00093C18.9893 7.27671 18.766 7.50042 18.4902 7.50093L13.2528 7.51074Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#222222"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#222222"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#222222"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#222222"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#222222"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.24fb3dd7.svg";
export { ForwardRef as ReactComponent };